import React from "react";

const TTS_LOCALE_BY_LANGUAGE_CODE = {
    ar: "ar",
    de: "de-DE",
    en: "en-US",
    es: "es-ES",
    fr: "fr-FR",
    it: "it-IT",
    ja: "ja-JP",
    nl: "nl-NL",
    pt: "pt-PT",
    ru: "ru-RU",
    tr: "tr-TR",
    zh: "zh-CN",
};

const normalizeDisplayText = (text, languageCode) => {
    const trimmedText = (text || "").trim();
    const normalizedText = trimmedText.toLowerCase();

    if (languageCode === "es" && normalizedText === "que o ese") {
        return "que / ese";
    }

    return trimmedText;
};

const getDisplayFontSize = (displayText) => {
    const textLength = displayText.length;

    if (textLength > 42) {
        return "11px";
    }
    if (textLength > 34) {
        return "12px";
    }
    if (textLength > 26) {
        return "13px";
    }
    if (textLength > 18) {
        return "14px";
    }
    if (textLength > 12) {
        return "15px";
    }

    return "16px";
};

const Word = ({
    isBlinking, // Determines if the word should blink
    isMatchedGlow,
    isSelected,
    language_code,
    onSelect,
    text,
    soundsEnabled,
    total_width,
}) => {
    const displayText = normalizeDisplayText(text, language_code);
    const displayFontSize = getDisplayFontSize(displayText);

    const playAudio = () => {
        if (!soundsEnabled) {
            return;
        }

        if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
            console.warn("Speech synthesis is not available in this browser.");
            return;
        }

        window.speechSynthesis.cancel();
        const utterance = new SpeechSynthesisUtterance(displayText);
        utterance.lang = TTS_LOCALE_BY_LANGUAGE_CODE[language_code] || language_code;
        utterance.rate = 0.9;
        window.speechSynthesis.speak(utterance);
    };

    const styles = {
        wordContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "6px 10px",
            margin: "4px 0",
            background: isMatchedGlow
                ? "linear-gradient(to bottom, #2ee66f, #0f9f47)"
                : isBlinking ? "red" : "linear-gradient(to bottom, #007BFF, #0056b3)",
            border: isMatchedGlow ? "2px solid #FFF176" : isSelected ? "2px solid #FFD54F" : "2px solid #28A745",
            borderRadius: "8px",
            textAlign: "center",
            width: total_width, // Dynamic width from parent
            minWidth: total_width,
            height: "48px",
            minHeight: "48px",
            boxSizing: "border-box",
            color: "#FFF",
            fontWeight: "bold",
            boxShadow: isMatchedGlow
                ? "0 0 10px rgba(255, 241, 118, 0.72), 0 0 18px rgba(46, 230, 111, 0.42)"
                : isSelected
                ? "0px 0px 14px rgba(255, 213, 79, 0.9)"
                : "0px 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "box-shadow 0.2s, background 0.3s, border 0.3s",
            cursor: "pointer",
        },
        textSpan: {
            flexGrow: 1, // Make the span take the remaining width
            textAlign: "center",
            minWidth: 0,
            fontSize: displayFontSize,
            lineHeight: 1.12,
            whiteSpace: "normal",
            overflow: "hidden",
            overflowWrap: "break-word",
            wordBreak: "normal",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
        },
        button: {
            width: "24px",
            minWidth: "24px",
            height: "24px",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            color: "#FFF",
            padding: 0,
            alignSelf: "center",
        },
    };
    console.log(isBlinking, " = isBlinking")

    return (
        <div
      className={`word ${isBlinking ? "blinking" : ""}`}

      style={styles.wordContainer}
      onClick={onSelect}
    >
      <span className="word-text" style={styles.textSpan}>{displayText}</span>
      {soundsEnabled ? (
        <button
          type="button"
          style={styles.button}
          onClick={(event) => {
            event.stopPropagation();
            playAudio();
          }}
        >
          🔊
        </button>
      ) : null}
    </div>
    );
};

export default Word;
